<template>
  <div>
    <div class="login">
      <h1>Welcome to TimelineBuilder!</h1>
      <p>TimelineBuilder is a free digital data visualization tool made to ease creation of timeline visualizations for social studies education. We aim for the creation of timelines to be focused on an understanding of chronology and consequence.</p>

      <p><router-link to="01"><button class="student-button">Start with an untitled Timeline</button></router-link></p>
      <p><router-link to="96043071-d0ce-4604-90b4-e6a26ae4a97e"><button class="teacher-button">Start with an Ancient Civilization themed Timeline</button></router-link></p>
      <p><a href="https://docs.google.com/document/d/1JxY0DTSmtVKU25kTfKA-Rnj27MZpXbD24Jt_mM5_maw" target="_blank"><button class="student-button">View a short tutorial</button></a></p>

      <img :src="image" alt="Example TimelineBuilder Timeline" width="50%"/>
      
      <!-- <p><router-link to="100"><button class="student-button">Student</button></router-link></p>
      <p><router-link to="login"><button class="teacher-button">Educator</button></router-link></p> -->
    </div>
  </div>
</template>

<script>
import image from "../assets/img/exampletimeline.png"

export default {
  name: 'Home',
  data: function () {
    return {
      image: image
    }
  }
}
</script>

<style>
.login {
  width: 100%;
  position: absolute;
}

.student-button {
  background-color: var(--block-orange);
  font-family: system-ui, sans-serif;
  font-weight: 500;
  border-radius: 5px;
  border: none;
  color: white;
  padding: 0.5%;
}

.student-button:hover{
  cursor: pointer;
}

.teacher-button {
  background-color: var(--form-blue);
  font-family: system-ui, sans-serif;
  font-weight: 500;
  border-radius: 5px;
  border: none;
  color: white;
  padding: 0.5%;
}

.teacher-button:hover {
  cursor: pointer;
}

html{
  height: 100vh; /*both html and body*/
}
body {
  height: 100vh; /*reset default margin*/
}

</style>
